
Select a color: 
<ngx-colors ngx-colors-trigger style="display: inline-block; margin:5px;" [(ngModel)]="selectedColor"  (change)="handleChange($event)"></ngx-colors>
<!-- <mat-form-field>
    <input matInput [(ngModel)]="selectedColor">
</mat-form-field> -->

<!-- <ngx-colors ngx-colors-trigger [(ngModel)]="leftColor"></ngx-colors>
<mat-form-field>
    <input matInput [(ngModel)]="leftColor">
</mat-form-field> -->

<!-- <hr> -->
<p>Color: {{ selectedColor }}</p>